module.exports = __webpack_public_path__ + "static/img/oops1.2980b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/oops1.jpg
// module id = zTah
// module chunks = 0